import { createFileRoute } from '@tanstack/react-router'
import { DocumentTypesSettings } from '@/features/organizations/settings/document-types'

export const Route = createFileRoute(
  '/_authenticated/_organization/organizations/settings/document-types'
)({
  component: DocumentTypesSettings,
})
